<template>
<div class="wrapper">
  <div id="manage-wrapper" v-if="isMatchPath">
    <div class="ibox-tools view-title">
      <h1 class="info-menu view-name">
        <img src="static/img/assets/nav_manage_on_2.png" alt="">
        {{$t('okrNetworkStr')}}
      </h1>
      <span class="info-right">
      </span>
    </div>
    <div class="input-group date mb-4">
      <label class="control-label">{{$t('periodStr')}}：</label>
      <span class="input-group-addon text-right"><i class="fa fa-calendar" @click="openPickerS"></i></span>
      <datepicker
        :language="datepickerLocale[checkLanguage]"
        :format='format'
        :typeable='true'
        placeholder="Select Date"
        v-model="dateS"
        ref="programaticOpenS"></datepicker>
      <span>〜</span>
      <span class="input-group-addon text-right"><i class="fa fa-calendar" @click="openPickerE"></i></span>
      <datepicker
        :language="datepickerLocale[checkLanguage]"
        :format='format'
        :typeable='true'
        placeholder="Select Date"
        v-model="dateE"
        ref="programaticOpenE"></datepicker>
      </div>
    <manage-wrapper-component require-admin>
      <net-work :date="{from: dateS, to: dateE}"></net-work>
    </manage-wrapper-component>
    <!-- </div> -->
  </div>
</div>
</template>

<script>
// import NoticeItem from '@/components/Notice/NoticeItem'
// import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import OrganizationItem from '@/components/People/OrganizationItem'
import ManageWrapperComponent from '@/components/Manage/ManageWrapperComponent'
import NetWork from '@/components/Okr/Network'
import NetWorkContentSVG from '@/components/Okr/netWorkContentSVG'
import Datepicker from 'vuejs-datepicker'
import moment from 'moment'
import { i18n } from '@/main.js'
import {ja, en, zh} from 'vuejs-datepicker/dist/locale'
export default {
  name: 'OkrNetwork',
  mixedins: [validationMixin],
  components: {
    // NoticeItem
    OrganizationItem,
    ManageWrapperComponent,
    NetWork,
    Datepicker,
    NetWorkContentSVG
  },
  data: function () {
    return {
      tag: 'OkrNetwork',
      open: false,
      searchType: 'dueDate',
      fromDate: moment().toDate(),
      toDate: moment().toDate(), // 絞り込む時にtoDateは現状は指定されていないのでとりあえず999年後にしておく
      format: 'yyyy/MM/dd',
      checkedUsers: [],
      checkedGroup: [],
      deleteUsers: {},
      groupUsers: {},
      groups: {},
      searchText: '',
      groupName: '',
      oldMembers: [],
      groupOwnerId: '',
      ownerEdit: false,
      id: this.$route.params.id,
      isRegistering: false,
      showModal: false,
      checkOrganization: '',
      // parentOrganization
      checkedOrganization: '',
      childGroups: {},
      depth: 1,
      checkedDepth: 0,
      dateS: moment().format('YYYY/MM/DD'),
      dateE: moment().format('YYYY/MM/DD'),
      datepickerLocale: {
        ja: ja,
        en: en,
        zh_tr: zh
      }
    }
  },
  validations: {
    groupName: {
      required
    }
  },
  computed: {
    checkLanguage () {
      return i18n.locale
    },
    isMatchPath () {
      return this.$route.name === 'OkrNetwork'
    }
  },
  mounted: function () {

  },
  methods: {
    openPickerFrom: function () {
      this.$refs.programaticOpenFrom.showCalendar()
    },
    openPickerTo: function () {
      this.$refs.programaticOpenTo.showCalendar()
    },
    clearDate: function (type) {
      if (type === 'from') {
        this.fromDate = ''
      } else {
        this.toDate = ''
      }
    },
    openPickerS: function () {
      this.$refs.programaticOpenS.showCalendar()
    },
    openPickerE: function () {
      this.$refs.programaticOpenE.showCalendar()
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.ibox-child
span.crown-mark {
  top: 1.0rem;
  left: -1.8rem;
    /* text-shadow: 16px -6px black; */
}
.border-none {
  border: none;
}
.parentPath {
  margin-top: 8px;
}

.grab-bing {
cursor : -webkit-grab;
cursor : -moz-grab;
cursor : -o-grab;
cursor : grab;
}
.grab-bing:active {
cursor : -webkit-grabbing;
cursor : -moz-grabbing;
cursor : -o-grabbing;
cursor : grabbing;
}
#box {
    position: relative;
    width: 60%;
    height: 300px;
    overflow: hidden;
    border: 1px solid #000;
    padding:10px;
  }
.content {
  width: 50px;
  height: 50px;
  border: 1px solid #000;
  position: absolute;
}
.input-searchType {
  display: flex;
}
.select-date {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/manage/OkrNetwork.vue